import { RootScopeEvents } from '../../../../common/services/root-scope-types';
import { AngularServices, } from '../../../../modules/core';
export class PublisherErrorHandler {
    constructor($injector) {
        this.$injector = $injector;
        this.isFixApplied = false;
        const $log = $injector.get('$log');
        this.debug = $log.debug.bind($log, `PublisherErrorHandler:${this.errorName}:`);
        this.$rootScope = $injector.get(AngularServices.RootScope);
    }
    onSuccess() {
        if (this.isFixApplied) {
            this.notify({ isFixed: true });
            this.isFixApplied = false;
        }
    }
    notify({ isFixed }) {
        this.$rootScope.$emit(RootScopeEvents.ACTIVE_PROVIDER.PUBLISHER_ERROR, {
            errorName: this.errorName,
            isFixed,
        });
    }
}
